import sortBy from 'lodash/sortBy';
import orderBy from 'lodash/orderBy';
import find from 'lodash/find';
import Vue from 'vue';

export default {
  getCourseLayoutFullScreenStatus(state) {
    return state.fullScreen;
  },
  hasTeacherPermissionsInCourse(state, { getProfile }) {
    if (Vue.router.currentRoute.name === 'walkthrough.feed') {
      return true;
    }
    const user_id = getProfile.id;
    const me = find(state.courseDetail.users, (user) => user.id === user_id);
    if (me) {
      const { role } = me.subscription;
      return role === 'author' || role === 'co-teacher' || role === 'admin';
    }
    return false;
  },
  getMySubscription(state, { getProfile }) {
    if (Vue.router.currentRoute.name === 'walkthrough.feed') {
      return true;
    }
    const user_id = getProfile.id;
    const me = find(state.courseDetail.users, (user) => user.id === user_id);
    if (me) {
      return me.subscription;
    }
  },
  // TODO: depreacate this getter
  getRoleInCourse(state, { getProfile }) {
    if (Vue.router.currentRoute.name === 'walkthrough.feed') {
      return 'author';
    }
    const me = find(state.courseDetail.users, (user) => user.id === getProfile.id);
    return me ? me.subscription.role : null;
  },
  getStudentsInCourse(state) {
    if (state.courseDetail.users) {
      return (
        state.courseDetail.users.filter(
          (user) => user.subscription.role === 'student'
        ) || []
      );
    }
    return [];
  },
  getCourses(state) {
    return state.courseList;
  },
  getCoursesInstructor(state) {
    return state.courseList.filter((course) => {
      if (course.users[0].subscription.role === 'author') {
        return course;
      }
    });
  },
  getTotalInstructorCourses(state) {
    return state.total_instructor_courses;
  },
  getTotalParticipantCourses(state) {
    return state.total_participant_courses;
  },
  getInstructorCourses(state) {
    return state.instructor_courses;
  },
  getParticipantCourses(state) {
    return state.participant_courses;
  },
  getCourseLoading(state) {
    return state.loading;
  },
  getCourseDetail(state) {
    return state.courseDetail;
  },
  getOrderedOnlineRTs(state, getters) {
    return (
      orderBy(
        getters.getCourseDetail.roundtables,
        ['is_ended', 'is_published', 'created_at'],
        ['asc', 'desc', 'desc']
      ) || []
    );
  },
  getCourseSequences(state, getters) {
    return getters.getCourseDetail.sequences;
  },
  getDrafs(state, getters) {
    return getters.getCourseDetail.drafts;
  },
  getOrderedLiveDiscussions(state, getters) {
    return (
      orderBy(
        getters.getCourseDetail.live_discussions,
        ['is_live', 'is_ended', 'is_published', 'published_date'],
        ['desc', 'asc', 'desc', 'desc']
      ) || []
    );
  },
  getOrderedActivities(state, getters) {
    const discussions = getters.getCourseDetail.live_discussions.map((ld) => {
      ld.type = 'live_discussion';
      return ld;
    });

    const roundtables = getters.getCourseDetail.roundtables.map((rt) => {
      rt.type = 'roundtable';
      return rt;
    });

    const activities = [...discussions, ...roundtables];

    // Sort in this order:
    // 1) Discussions that are live
    // 2) Activities that are active
    // 3) Activities not published
    // 4) Activities by publihsed date
    return sortBy(activities, [
      (activity) => !activity.is_live, // Discussions Live
      (activity) => !(activity.is_published && !activity.is_ended), // Activities Active
      (activity) => activity.is_published, // Activities not published
      (activity) => new Date(activity.published_date) * -1, // By published date
    ]);
  },
  getCurrentActivityType(state) {
    return state.current_activity_type;
  },
  getDashboardRole(state) {
    return state.dashboard_role;
  },
  showSlidingRoundtableList(state) {
    return state.showSlidingRoundtableList;
  },
  studentHasJoinedFirstOnlineRT(state, getters) {
    const course = getters.getCourses.find(
      c => c.id === getters.getCourseDetail.id
    );
    if (course) {
      return course.users[0].subscription.has_joined_first_roundtable;
    }
    return false;
  },
  studentHasJoinedFirstLiveRT(state, getters) {
    const course = getters.getCourses.find(
      c => c.id === getters.getCourseDetail.id
    );
    if (course) {
      return course.users[0].subscription.has_joined_first_live_discussion;
    }
    return false;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/courses/getters.js